exports.appStatus="PROD"; // UAT / PROD ISINYa
